import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelperService } from '../../helper.service';
import { FieldInspectionDialogComponent } from '../../dialogs/pin-rework-dialogs/field-inspection-dialog/field-inspection-dialog.component';
import { ReportListItem } from '../../field-inspection/models/inspection-report.model';

@Component({
  selector: 'app-field-inspections-tab',
  template: `
    <app-report-list
      [tenantId]="tenantId"
      [hidePinRequiredActions]="true"
      [showFilters]="true"
      [fullWidth]="true"
      (openExistingReport)="openReport($event)">
    </app-report-list>
  `,
  standalone: false
})
export class FieldInspectionsTabComponent implements OnInit {
  tenantId: number | null = null;

  constructor(
    private helper: HelperService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.tenantId = this.helper.getTenantId() ?? null;
  }

  openReport(event: { reportId: string; viewOnly: boolean }): void {
    this.dialog.open(FieldInspectionDialogComponent, {
      width: '720px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'fi-dialog-panel',
      data: {
        pinId: null,
        fieldId: null,
        tenantId: this.tenantId,
        farm: '',
        field: '',
        lat: 0,
        lng: 0,
        viewOnly: event.viewOnly,
        _openReportId: event.reportId
      }
    });
  }
}
